import React, { createContext, useContext, useState } from 'react';

const ComparisonContext = createContext();

export const useComparison = () => {
  const context = useContext(ComparisonContext);
  if (!context) {
    throw new Error('useComparison must be used within a ComparisonProvider');
  }
  return context;
};

export const ComparisonProvider = ({ children }) => {
  const [comparedCars, setComparedCars] = useState([]);
  const [showComparison, setShowComparison] = useState(false);

  const addToComparison = (car) => {
    if (!comparedCars.find(c => c.id === car.id)) {
      setComparedCars([...comparedCars, car]);
    }
  };

  const removeFromComparison = (carId) => {
    setComparedCars(comparedCars.filter(c => c.id !== carId));
  };

  const toggleComparison = () => {
    setShowComparison(!showComparison);
  };

  const isInComparison = (carId) => {
    return comparedCars.some(c => c.id === carId);
  };

  const clearComparison = () => {
    setComparedCars([]);
    setShowComparison(false);
  };

  const reorderComparedCars = (newOrder) => {
    setComparedCars(newOrder);
  };

  return (
    <ComparisonContext.Provider
      value={{
        comparedCars,
        showComparison,
        addToComparison,
        removeFromComparison,
        toggleComparison,
        isInComparison,
        clearComparison,
        reorderComparedCars
      }}
    >
      {children}
    </ComparisonContext.Provider>
  );
};
